var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOneSolidTwoDottedLine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 139",
    width: 8,
    height: 139,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "One Solid Two Dotted Lines-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m599.75-143v562.75h-999.75v-562.75z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t\t.s1 { fill: #292929 } \n\t\t.s2 { fill: #000000 } \n\t\t.s3 { fill: #101010 } \n\t\t.s4 { fill: #8a8a8a } \n\t\t.s5 { fill: #3b3b3b } \n\t\t.s6 { fill: #393939 } \n\t\t.s7 { fill: #2f2f2f } \n\t\t.s8 { fill: #2e2e2e } \n\t\t.s9 { fill: #2d2d2d } \n\t\t.s10 { fill: #303030 } \n\t\t.s11 { fill: #313131 } \n\t\t.s12 { fill: #2c2c2c } \n\t\t.s13 { fill: #323232 } \n\t\t.s14 { fill: #353535 } \n\t\t.s15 { fill: #343434 } \n\t\t.s16 { fill: #363636 } \n\t\t.s17 { fill: #383838 } \n\t\t.s18 { fill: #242424 } \n\t\t.s19 { fill: #272727 } \n\t\t.s20 { fill: #262626 } \n\t\t.s21 { fill: #3a3a3a } \n\t\t.s22 { fill: #333333 } \n\t\t.s23 { fill: #252525 } \n\t\t.s24 { fill: #373737 } \n\t\t.s25 { fill: #2b2b2b } \n\t\t.s26 { fill: #2a2a2a } \n\t\t.s27 { fill: #282828 } \n\t\t.s28 { fill: #1e1e1e } \n\t\t.s29 { fill: #1f1f1f } \n\t\t.s30 { fill: #202020 } \n\t\t.s31 { fill: #232323 } \n\t\t.s32 { fill: #191919 } \n\t\t.s33 { fill: #1a1a1a } \n\t\t.s34 { fill: #1b1b1b } \n\t\t.s35 { fill: #171717 } \n\t\t.s36 { fill: #161616 } \n\t\t.s37 { fill: #181818 } \n\t\t.s38 { fill: #1c1c1c } \n\t\t.s39 { fill: #1d1d1d } \n\t\t.s40 { fill: #080808 } \n\t\t.s41 { fill: #040404 } \n\t\t.s42 { fill: #050505 } \n\t\t.s43 { fill: #070707 } \n\t\t.s44 { fill: #090909 } \n\t\t.s45 { fill: #0b0b0b } \n\t\t.s46 { fill: #060606 } \n\t\t.s47 { fill: #0a0a0a } \n\t\t.s48 { fill: #111111 } \n\t\t.s49 { fill: #121212 } \n\t\t.s50 { fill: #151515 } \n\t\t.s51 { fill: #141414 } \n\t\t.s52 { fill: #131313 } \n\t\t.s53 { fill: #515151 } \n\t\t.s54 { fill: #535353 } \n\t\t.s55 { fill: #545454 } \n\t\t.s56 { fill: #4f4f4f } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m-400 416.2c329.9 0 659.8 0 999.8 0q0 1.8 0 3.5c-330 0-659.9 0-999.8 0q0-1.7 0-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m-400-143c329.9 0 659.8 0 999.8 0q0 1.7 0 3.5c-330 0-659.9 0-999.8 0q0-1.7 0-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-399.8-0.9c329.8 0 659.6 0 999.3 0q0 0.6 0 1.2c-329.8 0-659.5 0-999.3 0q0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-399.8 276.4c329.8 0 659.6 0 999.3 0q0 0.7 0 1.3c-329.7 0-659.3 0-999 0q-0.1-0.6-0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-400 415.2c329.9 0 659.8 0 999.8 0q0 0.5 0 1c-330 0-659.9 0-999.8 0q0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-400-139.5c329.9 0 659.8 0 999.8 0q0 0.5 0 1c-330 0-659.9 0-999.8 0q0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-399.5 137.9c329.7 0 659.3 0 999 0q0 0.5 0 1c-329.7 0-659.3 0-999 0q0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m137.1 322.5q2.2 0 4.5 0 0 0.7 0 1.5-1 0-2.1 0-0.3 0-0.6 0-0.8 0-1.5 0-0.2-0.2-0.3-0.3 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m-21.8 322.5q2.2 0 4.5 0 0 0.7 0 1.5-1.1 0-2.2 0-0.3 0-0.6 0-0.7 0-1.5 0-0.1-0.2-0.2-0.3 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m-362.5 322.5q2.2 0 4.5 0 0 0.7 0 1.5-1.1 0-2.1 0-0.3 0-0.6 0-0.8 0-1.6 0-0.1-0.2-0.2-0.3 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m8.4 322.7q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m-302 322.7q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m530.8 230.2q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m500.5 230.2q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m477.8 230.2q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m455 230.2q2.3 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m371.8 230.2q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m318.8 230.2q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m296.1 230.2q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m159.9 230.2q2.2 0 4.5 0 0 0.6 0 1.2-2.3 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m137.1 230.2q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m114.4 230.2q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m31.1 230.2q2.3 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m0.9 230.2q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m-21.8 230.2q2.2 0 4.5 0 0 0.6 0 1.2-2.3 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-44.6 230.2q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-120.3 230.2q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m-180.8 230.2q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m-203.5 230.2q2.2 0 4.4 0 0 0.6 0 1.2-2.2 0-4.4 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m-256.5 230.2q2.2 0 4.5 0 0 0.6 0 1.2-2.3 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m-279.3 230.2q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m-302 230.2q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m-339.8 230.2q2.3 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m-362.5 230.2q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-385.3 230.2q2.3 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m-302 183.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m477.8 183.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m455 183.9q2.3 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m296.1 183.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m159.9 183.9q2.2 0 4.5 0 0 0.6 0 1.2-2.3 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s15",
    d: "m137.1 183.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m0.9 183.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s15",
    d: "m-21.8 183.9q2.2 0 4.5 0 0 0.6 0 1.2-2.3 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m-180.8 183.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m-203.5 183.9q2.2 0 4.4 0 0 0.6 0 1.2-2.2 0-4.4 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m-256.5 183.9q2.2 0 4.5 0 0 0.6 0 1.2-2.3 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m-279.3 183.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m-339.8 183.9q2.3 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s15",
    d: "m-362.5 183.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m538.3 91.6q2.2 0 4.5 0 0 0.6 0 1.3-2.3 0-4.5 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m477.8 91.6q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m455 91.6q2.3 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m379.3 91.6q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m356.6 91.6q2.2 0 4.5 0 0 0.6 0 1.3-2.3 0-4.5 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m197.6 91.6q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m38.6 91.6q2.3 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m-256.5 91.6q2.2 0 4.5 0 0 0.6 0 1.3-2.3 0-4.5 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m-279.3 91.6q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m583.8 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.3 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m561 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m538.3 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.3 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m500.5 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m477.8 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m455 45.3q2.3 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m402 45.3q2.3 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m379.3 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s15",
    d: "m356.6 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.3 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m318.8 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m243.1 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m220.3 45.3q2.3 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m197.6 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m167.4 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.3 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m84.1 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m61.4 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m38.6 45.3q2.3 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-14.3 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.3 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-97.6 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-120.3 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-173.3 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m-256.5 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.3 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m-279.3 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-302 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-332.3 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m500.5-47.2q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m318.8-47.2q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m8.4-47.2q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s18",
    d: "m591.5 368.7q2.1 0 4.3 0 0 0.6 0 1.3-2.3 0-4.5 0 0.1-0.6 0.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m561.3 368.7q2.1 0 4.2 0 0 0.6 0 1.3-2.2 0-4.5 0 0.1-0.6 0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m538.5 368.7q2.1 0 4.3 0 0 0.6 0 1.3-2.3 0-4.5 0 0.1-0.6 0.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m447.5 368.7q2.1 0 4.3 0 0.1 0.6 0.2 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s18",
    d: "m432.5 368.7q2.1 0 4.3 0 0 0.6 0 1.3-2.2 0-4.5 0 0.1-0.6 0.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m379.6 368.7q2 0 4.2 0 0 0.6 0 1.3-2.2 0-4.5 0 0.1-0.6 0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m341.6 368.7q2.1 0 4.2 0 0.1 0.6 0.3 1.3-2.3 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m288.6 368.7q2.1 0 4.2 0 0.1 0.6 0.3 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m273.6 368.7q2.1 0 4.2 0 0 0.6 0 1.3-2.2 0-4.5 0 0.2-0.6 0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m220.6 368.7q2.1 0 4.2 0 0 0.6 0 1.3-2.2 0-4.5 0 0.2-0.6 0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m197.9 368.7q2 0 4.2 0 0 0.6 0 1.3-2.2 0-4.5 0 0.1-0.6 0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m91.9 368.7q2.1 0 4.2 0 0 0.6 0 1.3-2.2 0-4.5 0 0.2-0.6 0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m61.6 368.7q2.1 0 4.3 0 0 0.6 0 1.3-2.2 0-4.5 0 0.1-0.6 0.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m38.9 368.7q2.1 0 4.2 0 0 0.6 0 1.3-2.2 0-4.5 0 0.2-0.6 0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-52.1 368.7q2.1 0 4.3 0 0.1 0.6 0.2 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m-67.1 368.7q2.1 0 4.3 0 0 0.6 0 1.3-2.2 0-4.5 0 0.1-0.6 0.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-226 368.7q2 0 4.2 0 0 0.6 0 1.3-2.2 0-4.5 0 0.1-0.6 0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s18",
    d: "m-233.8 368.7q2.1 0 4.3 0 0.1 0.6 0.2 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-324.5 368.7q2.1 0 4.2 0 0 0.6 0 1.3-2.2 0-4.5 0 0.2-0.6 0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m508 322.7q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.2-0.7-0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m500.5 322.7q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.1-0.7-0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m349.1 322.7q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.7-0.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m341.6 322.7q2.2 0 4.5 0-0.2 0.6-0.3 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m318.8 322.7q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.2-0.7-0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m273.3 322.7q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.1-0.7-0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m250.6 322.7q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.7-0.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m227.8 322.7q2.3 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.1-0.7-0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m167.4 322.7q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.7-0.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m91.6 322.7q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.1-0.7-0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m68.9 322.7q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.7-0.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m-14.3 322.7q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.7-0.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m-67.3 322.7q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.7-0.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m-90.1 322.7q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.2-0.7-0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m-112.8 322.7q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.7-0.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m-143.1 322.7q2.3 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.1-0.7-0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m-150.6 322.7q2.3 0 4.5 0-0.1 0.6-0.2 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m-173.3 322.7q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.7-0.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m-226.3 322.7q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.2-0.7-0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m-249 322.7q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.7-0.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m-271.8 322.7q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.2-0.7-0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m-324.8 322.7q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.1-0.7-0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m-332.3 322.7q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.1-0.7-0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m584 230.2q2.1 0 4.3 0 0 0.6 0 1.2-2.3 0-4.5 0 0.1-0.6 0.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m561.3 230.2q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m538.5 230.2q2.1 0 4.3 0 0 0.6 0 1.2-2.3 0-4.5 0 0.1-0.6 0.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m508.3 230.2q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m470.3 230.2q2.1 0 4.2 0 0.2 0.6 0.3 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m447.5 230.2q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m402.3 230.2q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.2-0.6 0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m379.6 230.2q2 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m349.3 230.2q2.1 0 4.3 0 0 0.6 0 1.2-2.3 0-4.5 0 0.1-0.6 0.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m341.6 230.2q2.1 0 4.2 0 0.1 0.6 0.3 1.2-2.3 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m311.3 230.2q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m288.6 230.2q2.1 0 4.2 0 0.1 0.6 0.3 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m243.3 230.2q2.1 0 4.3 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m220.6 230.2q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.2-0.6 0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m197.9 230.2q2 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m190.4 230.2q2 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m167.6 230.2q2.1 0 4.3 0 0 0.6 0 1.2-2.3 0-4.5 0 0.1-0.6 0.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m129.6 230.2q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m84.4 230.2q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.2-0.6 0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m61.6 230.2q2.1 0 4.3 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m38.9 230.2q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.2-0.6 0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m8.6 230.2q2.1 0 4.3 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m-14.1 230.2q2.1 0 4.3 0 0 0.6 0 1.2-2.3 0-4.5 0 0.1-0.6 0.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-29.3 230.2q2 0 4.2 0 0.1 0.6 0.3 1.2-2.3 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-52.1 230.2q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-97.3 230.2q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-142.8 230.2q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.2-0.6 0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-173.1 230.2q2.1 0 4.3 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m-324.5 230.2q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.2-0.6 0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-332 230.2q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.2-0.6 0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s22",
    d: "m538.5 183.9q2.1 0 4.3 0 0 0.6 0 1.2-2.3 0-4.5 0 0.1-0.6 0.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s22",
    d: "m508.3 183.9q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s22",
    d: "m470.3 183.9q2.1 0 4.2 0 0.2 0.6 0.3 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m447.5 183.9q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s22",
    d: "m349.3 183.9q2.1 0 4.3 0 0 0.6 0 1.2-2.3 0-4.5 0 0.1-0.6 0.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m341.6 183.9q2.1 0 4.2 0 0.1 0.6 0.3 1.2-2.3 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s22",
    d: "m311.3 183.9q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m288.6 183.9q2.1 0 4.2 0 0.1 0.6 0.3 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s22",
    d: "m273.6 183.9q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.2-0.6 0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m250.8 183.9q2.1 0 4.3 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s22",
    d: "m197.9 183.9q2 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s22",
    d: "m129.6 183.9q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m91.9 183.9q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.2-0.6 0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m69.1 183.9q2.1 0 4.3 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s22",
    d: "m38.9 183.9q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.2-0.6 0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m8.6 183.9q2.1 0 4.3 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s22",
    d: "m-29.3 183.9q2 0 4.2 0 0.1 0.6 0.3 1.2-2.3 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m-52.1 183.9q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m-67.1 183.9q2.1 0 4.3 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m-89.8 183.9q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s22",
    d: "m-142.8 183.9q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.2-0.6 0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s22",
    d: "m-226 183.9q2 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m-248.8 183.9q2.1 0 4.3 0 0 0.6 0 1.2-2.3 0-4.5 0 0.1-0.6 0.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m-324.5 183.9q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.2-0.6 0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m447.5 91.6q2.3 0 4.5 0-0.1 0.6-0.2 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m424.8 91.6q2.2 0 4.5 0-0.1 0.6-0.3 1.3-2 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m341.6 91.6q2.2 0 4.5 0-0.2 0.6-0.3 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m288.6 91.6q2.2 0 4.5 0-0.1 0.6-0.3 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m265.8 91.6q2.2 0 4.5 0-0.1 0.6-0.2 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m250.6 91.6q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.7-0.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s22",
    d: "m227.8 91.6q2.3 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.1-0.7-0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s22",
    d: "m159.9 91.6q2.2 0 4.5 0-0.2 0.6-0.3 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m106.9 91.6q2.2 0 4.5 0-0.2 0.6-0.3 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m68.9 91.6q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.7-0.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m8.4 91.6q2.2 0 4.5 0-0.1 0.6-0.3 1.3-2 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s22",
    d: "m0.9 91.6q2.2 0 4.5 0-0.1 0.6-0.3 1.3-2 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m-52.1 91.6q2.2 0 4.5 0-0.1 0.6-0.2 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m-74.8 91.6q2.2 0 4.5 0-0.2 0.6-0.3 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m-90.1 91.6q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.2-0.7-0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s22",
    d: "m-112.8 91.6q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.7-0.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s22",
    d: "m-150.6 91.6q2.3 0 4.5 0-0.1 0.6-0.2 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s22",
    d: "m-180.8 91.6q2.2 0 4.5 0-0.1 0.6-0.3 1.3-2 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m-249 91.6q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.7-0.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s22",
    d: "m-271.8 91.6q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.2-0.7-0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m-324.8 91.6q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.1-0.7-0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s22",
    d: "m-339.8 91.6q2.3 0 4.5 0-0.1 0.6-0.2 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m530.8 45.3q2.2 0 4.5 0-0.2 0.6-0.3 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m371.8 45.3q2.2 0 4.5 0-0.1 0.6-0.2 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m341.6 45.3q2.2 0 4.5 0-0.2 0.6-0.3 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m296.1 45.3q2.2 0 4.5 0-0.1 0.6-0.3 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m250.6 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.6-0.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m227.8 45.3q2.3 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.1-0.6-0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m190.1 45.3q2.2 0 4.5 0-0.1 0.6-0.2 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m159.9 45.3q2.2 0 4.5 0-0.2 0.6-0.3 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m137.1 45.3q2.2 0 4.5 0-0.1 0.6-0.2 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m114.4 45.3q2.2 0 4.5 0-0.2 0.6-0.3 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m68.9 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.6-0.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m46.1 45.3q2.3 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.1-0.6-0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m31.1 45.3q2.3 0 4.5 0-0.1 0.6-0.2 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m8.4 45.3q2.2 0 4.5 0-0.1 0.6-0.3 1.3-2 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m0.9 45.3q2.2 0 4.5 0-0.1 0.6-0.3 1.3-2 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-21.8 45.3q2.2 0 4.5 0-0.2 0.6-0.3 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-44.6 45.3q2.2 0 4.5 0-0.1 0.6-0.2 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-90.1 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.2-0.6-0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-112.8 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.6-0.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-143.1 45.3q2.3 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.1-0.6-0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-150.6 45.3q2.3 0 4.5 0-0.1 0.6-0.2 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-180.8 45.3q2.2 0 4.5 0-0.1 0.6-0.3 1.3-2 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-203.5 45.3q2.2 0 4.4 0-0.1 0.6-0.2 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-249 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.6-0.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-271.8 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.2-0.6-0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-324.8 45.3q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.1-0.6-0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-339.8 45.3q2.3 0 4.5 0-0.1 0.6-0.2 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-362.5 45.3q2.2 0 4.5 0-0.1 0.6-0.3 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-385.3 45.3q2.3 0 4.5 0-0.1 0.6-0.2 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m561-47.2q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m508.3-47.2q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m470.3-47.2q2.1 0 4.2 0 0.2 0.6 0.3 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m447.5-47.2q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m424.8-47.2q2.1 0 4.2 0 0.2 0.6 0.3 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m349.3-47.2q2.1 0 4.3 0 0 0.6 0 1.2-2.3 0-4.5 0 0.1-0.6 0.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m341.6-47.2q2.1 0 4.2 0 0.1 0.6 0.3 1.2-2.3 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m311.3-47.2q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m288.6-47.2q2.1 0 4.2 0 0.1 0.6 0.3 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m265.8-47.2q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m220.3-47.2q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m159.9-47.2q2.1 0 4.2 0 0.1 0.6 0.3 1.2-2.3 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m129.6-47.2q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m106.9-47.2q2.1 0 4.2 0 0.1 0.6 0.3 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m61.4-47.2q2.1 0 4.2 0 0.2 0.6 0.3 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m0.9-47.2q2.1 0 4.2 0 0.2 0.6 0.3 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m-29.3-47.2q2 0 4.2 0 0.1 0.6 0.3 1.2-2.3 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m-52.1-47.2q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m-74.8-47.2q2.1 0 4.2 0 0.1 0.6 0.3 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m-120.3-47.2q2.1 0 4.2 0 0.2 0.6 0.3 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m-150.6-47.2q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m-180.8-47.2q2.1 0 4.2 0 0.2 0.6 0.3 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m-302-47.2q2.1 0 4.2 0 0.1 0.6 0.3 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m-324.5-47.2q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.2-0.6 0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m-339.8-47.2q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s18",
    d: "m591.3-93.2q2.2 0 4.5 0 0 0.6 0 1.2-2.1 0-4.3 0-0.1-0.6-0.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m447.5-93.2q2.3 0 4.5 0-0.1 0.6-0.2 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s18",
    d: "m432.3-93.2q2.2 0 4.5 0 0 0.6 0 1.2-2.1 0-4.3 0-0.1-0.6-0.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m424.8-93.2q2.2 0 4.5 0-0.1 0.6-0.3 1.2-2 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m341.6-93.2q2.2 0 4.5 0-0.2 0.6-0.3 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m288.6-93.2q2.2 0 4.5 0-0.1 0.6-0.3 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m265.8-93.2q2.2 0 4.5 0-0.1 0.6-0.2 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m159.9-93.2q2.2 0 4.5 0-0.2 0.6-0.3 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m106.9-93.2q2.2 0 4.5 0-0.2 0.6-0.3 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m0.9-93.2q2.2 0 4.5 0-0.1 0.6-0.3 1.2-2 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-52.1-93.2q2.2 0 4.5 0-0.1 0.6-0.2 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m-74.8-93.2q2.2 0 4.5 0-0.2 0.6-0.3 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-180.8-93.2q2.2 0 4.5 0-0.1 0.6-0.3 1.2-2 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s18",
    d: "m-233.8-93.2q2.2 0 4.5 0-0.1 0.6-0.2 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-324.8-93.2q2.2 0 4.5 0 0 0.6 0 1.2-2.1 0-4.2 0-0.1-0.6-0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-339.8-93.2q2.3 0 4.5 0-0.1 0.6-0.2 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s23",
    d: "m425 368.7q2 0 4 0 0.2 0.6 0.3 1.3-2.2 0-4.5 0 0.1-0.6 0.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s23",
    d: "m266.1 368.7q2 0 4 0 0.1 0.6 0.2 1.3-2.2 0-4.5 0 0.2-0.6 0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m107.1 368.7q2 0 4 0 0.1 0.6 0.3 1.3-2.2 0-4.5 0 0.1-0.6 0.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s23",
    d: "m-74.6 368.7q2 0 4 0 0.1 0.6 0.3 1.3-2.2 0-4.5 0 0.1-0.6 0.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-150.3 368.7q2 0 4 0 0.1 0.6 0.2 1.3-2.2 0-4.5 0 0.2-0.6 0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m508-93.2q2.2 0 4.5 0-0.1 0.6-0.2 1.2-2 0-4 0-0.2-0.6-0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m349.1-93.2q2.2 0 4.5 0-0.2 0.6-0.3 1.2-2 0-4 0-0.1-0.6-0.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m273.3-93.2q2.2 0 4.5 0-0.1 0.6-0.2 1.2-2 0-4 0-0.1-0.6-0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s23",
    d: "m91.6-93.2q2.2 0 4.5 0-0.1 0.6-0.2 1.2-2 0-4 0-0.1-0.6-0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s23",
    d: "m-67.3-93.2q2.2 0 4.5 0-0.2 0.6-0.3 1.2-2 0-4 0-0.1-0.6-0.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m-226.3-93.2q2.2 0 4.5 0-0.1 0.6-0.2 1.2-2 0-4 0-0.2-0.6-0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m530.8 322.7q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m523.3 322.7q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s24",
    d: "m515.8 322.7q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m371.8 322.7q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m356.8 322.7q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s24",
    d: "m296.3 322.7q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s24",
    d: "m190.1 322.7q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s24",
    d: "m175.1 322.7q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m114.6 322.7q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s24",
    d: "m16.1 322.7q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m-44.3 322.7q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s24",
    d: "m-203.3 322.7q2.1 0 4.2 0 0 0.6 0 1.3-2 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s24",
    d: "m-309.5 322.7q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m-385 322.7q2.1 0 4.2 0 0 0.6 0 1.3-2 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m523.3 230.2q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s25",
    d: "m515.8 230.2q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s26",
    d: "m493 230.2q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s27",
    d: "m485.5 230.2q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m356.8 230.2q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s26",
    d: "m334.1 230.2q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s27",
    d: "m326.6 230.2q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s26",
    d: "m273.6 230.2q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m250.8 230.2q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m228.1 230.2q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s26",
    d: "m205.3 230.2q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s25",
    d: "m175.1 230.2q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s26",
    d: "m152.4 230.2q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m91.9 230.2q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m69.1 230.2q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s26",
    d: "m46.4 230.2q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m23.6 230.2q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s25",
    d: "m16.1 230.2q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s26",
    d: "m-6.6 230.2q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-67.1 230.2q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-89.8 230.2q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-112.6 230.2q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s27",
    d: "m-127.8 230.2q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s26",
    d: "m-135.3 230.2q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s26",
    d: "m-226 230.2q2 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-248.8 230.2q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-271.5 230.2q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s27",
    d: "m-286.8 230.2q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s26",
    d: "m-294.3 230.2q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m523.3 183.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m515.8 183.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m493 183.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m485.5 183.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m356.8 183.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m334.1 183.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m326.6 183.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m228.1 183.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m205.3 183.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m175.1 183.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m167.6 183.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m152.4 183.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m46.4 183.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m23.6 183.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m16.1 183.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-6.6 183.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m-14.1 183.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-112.6 183.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m-127.8 183.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-135.3 183.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-173.1 183.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-271.5 183.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m-286.8 183.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-294.3 183.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-332 183.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s25",
    d: "m576.3 91.6q2 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m553.5 91.6q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m546 91.6q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m462.8 91.6q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s25",
    d: "m440 91.6q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s25",
    d: "m417.3 91.6q2.1 0 4.2 0 0 0.6 0 1.3-2 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m394.6 91.6q2 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s25",
    d: "m387.1 91.6q2 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m364.3 91.6q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m53.9 91.6q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m-105.1 91.6q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m-165.6 91.6q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s25",
    d: "m-188.3 91.6q2.1 0 4.2 0 0 0.6 0 1.3-2 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m-347.3 91.6q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s25",
    d: "m-370 91.6q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m530.8 91.6q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m523.3 91.6q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m493 91.6q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m485.5 91.6q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m470.3 91.6q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m371.8 91.6q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m334.1 91.6q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m326.6 91.6q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m311.3 91.6q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m212.8 91.6q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m205.3 91.6q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m182.6 91.6q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m152.4 91.6q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m129.6 91.6q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m46.4 91.6q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m31.1 91.6q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m23.6 91.6q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-6.6 91.6q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-29.3 91.6q2 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m-127.8 91.6q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-135.3 91.6q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-158.1 91.6q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m-286.8 91.6q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-294.3 91.6q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-317 91.6q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.7 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m576.3 45.3q2 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m553.5 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m546 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m523.3 45.3q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s26",
    d: "m493 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s27",
    d: "m485.5 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m470.3 45.3q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m462.8 45.3q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m447.5 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m440 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m424.8 45.3q2.1 0 4.2 0 0 0.6 0 1.3-2 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m417.3 45.3q2.1 0 4.2 0 0 0.6 0 1.3-2 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m394.6 45.3q2 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m364.3 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s26",
    d: "m334.1 45.3q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s27",
    d: "m326.6 45.3q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m311.3 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m288.6 45.3q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m265.8 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m258.3 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m235.6 45.3q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s27",
    d: "m212.8 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s26",
    d: "m205.3 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s25",
    d: "m182.6 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s26",
    d: "m152.4 45.3q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s26",
    d: "m129.6 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m106.9 45.3q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m99.4 45.3q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m76.6 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m53.9 45.3q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m23.6 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s26",
    d: "m-6.6 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-29.3 45.3q2 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-52.1 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m-59.6 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-74.8 45.3q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m-82.3 45.3q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-105.1 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s27",
    d: "m-127.8 45.3q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s26",
    d: "m-135.3 45.3q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s25",
    d: "m-158.1 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s27",
    d: "m-165.6 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-188.3 45.3q2.1 0 4.2 0 0 0.6 0 1.3-2 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m-211 45.3q2 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m-233.8 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m-241.3 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m-264 45.3q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s27",
    d: "m-286.8 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s26",
    d: "m-294.3 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s26",
    d: "m-309.5 45.3q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s25",
    d: "m-317 45.3q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s27",
    d: "m-347.3 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-370 45.3q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m-392.8 45.3q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m583.8-47.2q2 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m523.3-47.2q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m402-47.2q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m243.1-47.2q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s24",
    d: "m182.6-47.2q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m84.1-47.2q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m-97.6-47.2q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s24",
    d: "m-158.1-47.2q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m-173.1-47.2q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s24",
    d: "m-309.5-47.2q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s24",
    d: "m-317-47.2q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m-332-47.2q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s23",
    d: "m-399.5 368.7q1.7 0 3.5 0 0 0.6 0 1.3-1.8 0-3.8 0 0.2-0.6 0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s23",
    d: "m-399.8-93.2q1.9 0 3.8 0 0 0.6 0 1.2-1.7 0-3.5 0-0.1-0.6-0.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s28",
    d: "m591.3 322.7q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m568.5 322.7q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s28",
    d: "m432.3 322.7q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m409.5 322.7q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m386.8 322.7q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s31",
    d: "m159.9 322.7q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s31",
    d: "m0.9 322.7q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s31",
    d: "m-180.8 322.7q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s31",
    d: "m-339.8 322.7q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m424.8 230.4q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m265.8 230.4q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s33",
    d: "m106.9 230.4q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m-74.8 230.4q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "m-150.6 230.4q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m-188.3 230.4q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m-211 230.4q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m-233.8 230.4q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m-370 230.4q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m-392.8 230.4q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m591.3 184.1q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m568.5 184.1q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m432.3 184.1q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "m424.8 184.1q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m409.5 184.1q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "m265.8 184.1q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m106.9 184.1q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "m-74.8 184.1q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-150.6 184.1q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m-188.3 184.1q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-211 184.1q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-233.8 184.1q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m-370 184.1q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-392.8 184.1q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m591.3 91.6q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m568.5 91.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m508 91.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m432.3 91.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m409.5 91.6q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m349.1 91.6q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m273.3 91.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "m91.6 91.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "m-67.3 91.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m-211 91.6q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m-226.3 91.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-233.8 91.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m-392.8 91.6q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m591.3 45.3q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m568.5 45.3q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "m508 45.3q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m432.3 45.3q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m409.5 45.3q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m386.8 45.3q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "m349.1 45.3q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s33",
    d: "m273.3 45.3q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m91.6 45.3q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m-67.3 45.3q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s33",
    d: "m-226.3 45.3q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s31",
    d: "m-143.1-47q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-188.3-47q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m-211-47q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s28",
    d: "m-233.8-47q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m-279.3-47q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-370-47q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m-392.8-47q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m583.8 369q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m576.3 369q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m568.8 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m553.5 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m546 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m530.8 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m523.3 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m515.8 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m508 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m500.8 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m493 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m485.5 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m478 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m470.3 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m462.8 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m455.3 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m440 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m417.3 369q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m409.8 369q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m402 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m394.6 369q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m387.1 369q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m371.8 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m364.3 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m349.1 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m334.1 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m326.6 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m319.1 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m311.3 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m303.8 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m281.1 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m258.3 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m250.8 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m243.1 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m235.6 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m228.1 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m212.8 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m205.3 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m190.1 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m182.6 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m175.1 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m167.6 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m152.4 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m144.9 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m129.6 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m122.1 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m114.6 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m99.4 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m84.1 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m76.6 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m69.1 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m53.9 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m46.4 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m31.1 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s47",
    d: "m23.6 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m16.1 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m8.4 369q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m-6.6 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m-14.1 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m-29.3 369q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m-36.8 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m-44.3 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-59.6 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-82.3 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m-89.8 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m-97.6 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m-105.1 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m-112.6 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m-120.3 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m-127.8 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m-135.3 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m-143.1 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m-158.1 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m-165.6 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m-173.1 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-188.3 369q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m-195.8 369q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-211 369q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-218.5 369q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-241.3 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m-248.8 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-256.5 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-264 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m-271.5 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m-279.3 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m-286.8 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m-294.3 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m-302 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m-309.5 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m-317 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m-332 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m-347.3 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m-354.8 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-370 369q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-377.5 369q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m-385 369q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-392.8 369q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m553.5 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m546 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m478 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m462.8 322.7q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m394.6 322.7q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m364.3 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m303.8 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m144.9 322.7q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m53.9 322.7q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m-36.8 322.7q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m-105.1 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m-165.6 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m-195.8 322.7q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m-279.3 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m-347.3 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m-354.8 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m583.8 322.7q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m576.3 322.7q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m561 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m538.5 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m470.3 322.7q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m455.3 322.7q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "m447.5 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m440 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "m424.8 322.7q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m417.3 322.7q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m402 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m311.3 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "m288.6 322.7q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m281.1 322.7q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "m265.8 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m258.3 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m243.1 322.7q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m235.6 322.7q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m220.3 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m197.9 322.7q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m182.6 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m129.6 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m122.1 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m106.9 322.7q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m99.4 322.7q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m84.1 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m76.6 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m61.4 322.7q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m46.4 322.7q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m38.9 322.7q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m23.6 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m-29.3 322.7q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "m-52.1 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-59.6 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "m-74.8 322.7q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-82.3 322.7q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m-97.6 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "m-120.3 322.7q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-158.1 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-188.3 322.7q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-211 322.7q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-218.5 322.7q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-233.8 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-241.3 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-256.5 322.7q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-264 322.7q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-317 322.7q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-370 322.7q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-377.5 322.7q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-392.8 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m493 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s33",
    d: "m485.5 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m334.1 322.7q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s33",
    d: "m326.6 322.7q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s33",
    d: "m212.8 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m205.3 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m152.4 322.7q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s33",
    d: "m31.1 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m-6.6 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s33",
    d: "m-127.8 322.7q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m-135.3 322.7q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s33",
    d: "m-286.8 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m-294.3 322.7q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m591.5 230.4q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m576.3 230.4q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m568.8 230.4q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m553.5 230.4q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m546 230.4q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m462.8 230.4q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m440 230.4q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m432.5 230.4q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m417.3 230.4q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m409.8 230.4q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m394.6 230.4q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m387.1 230.4q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m364.3 230.4q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m303.8 230.4q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m281.1 230.4q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m258.3 230.4q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m235.6 230.4q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m212.8 230.4q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m182.6 230.4q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m144.9 230.4q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m122.1 230.4q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m99.4 230.4q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m76.6 230.4q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m53.9 230.4q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m-36.8 230.4q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-59.6 230.4q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-82.3 230.4q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m-105.1 230.4q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m-158.1 230.4q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m-165.6 230.4q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m-195.8 230.4q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-218.5 230.4q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-241.3 230.4q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-264 230.4q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m-309.5 230.4q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m-317 230.4q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m-347.3 230.4q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m-354.8 230.4q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-377.5 230.4q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m583.8 184.1q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m561 184.1q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m530.8 184.1q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m500.8 184.1q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m402 184.1q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m379.3 184.1q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m371.8 184.1q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m319.1 184.1q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m258.3 184.1q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m243.1 184.1q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m220.3 184.1q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s51",
    d: "m212.8 184.1q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m190.1 184.1q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m182.6 184.1q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m114.6 184.1q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m99.4 184.1q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m84.1 184.1q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m61.4 184.1q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s51",
    d: "m31.1 184.1q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m-44.3 184.1q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m-97.6 184.1q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m-120.3 184.1q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m-158.1 184.1q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m-241.3 184.1q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m-309.5 184.1q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m-317 184.1q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m-385 184.1q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m576.3 184.1q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s52",
    d: "m553.5 184.1q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s52",
    d: "m546 184.1q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s52",
    d: "m462.8 184.1q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m440 184.1q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m417.3 184.1q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s52",
    d: "m394.6 184.1q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m387.1 184.1q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s52",
    d: "m364.3 184.1q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s52",
    d: "m303.8 184.1q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m281.1 184.1q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m235.6 184.1q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s52",
    d: "m144.9 184.1q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m122.1 184.1q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m76.6 184.1q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s52",
    d: "m53.9 184.1q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s52",
    d: "m-36.8 184.1q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m-59.6 184.1q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m-82.3 184.1q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s52",
    d: "m-105.1 184.1q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s52",
    d: "m-165.6 184.1q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s52",
    d: "m-195.8 184.1q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m-218.5 184.1q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m-264 184.1q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s52",
    d: "m-347.3 184.1q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s52",
    d: "m-354.8 184.1q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m-377.5 184.1q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s52",
    d: "m303.8 91.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m281.1 91.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m235.6 91.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s52",
    d: "m144.9 91.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m122.1 91.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m76.6 91.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s52",
    d: "m-36.8 91.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m-59.6 91.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m-82.3 91.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s52",
    d: "m-195.8 91.6q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m-218.5 91.6q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m-264 91.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s52",
    d: "m-354.8 91.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m-377.5 91.6q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m583.8 91.6q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m561 91.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m515.8 91.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m500.8 91.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m402 91.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m319.1 91.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m296.3 91.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m258.3 91.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m243.1 91.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m220.3 91.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m175.1 91.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s51",
    d: "m167.6 91.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m137.4 91.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m114.6 91.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m99.4 91.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m84.1 91.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m61.4 91.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m16.1 91.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s51",
    d: "m-14.1 91.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m-21.6 91.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m-44.3 91.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m-97.6 91.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m-120.3 91.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-143.1 91.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m-173.1 91.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m-203.3 91.6q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m-241.3 91.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m-302 91.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m-332 91.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m-362.3 91.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m-385 91.6q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m515.8 45.3q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m303.8 45.3q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m281.1 45.3q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m175.1 45.3q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m144.9 45.3q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m122.1 45.3q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m16.1 45.3q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m-36.8 45.3q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m-195.8 45.3q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-218.5 45.3q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m-354.8 45.3q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-377.5 45.3q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m493-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m334.1-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m152.4-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m-6.6-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m591.5-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m576.3-47q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m568.8-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s28",
    d: "m538.5-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "m530.8-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m515.8-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s33",
    d: "m485.5-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m455.3-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m440-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m432.5-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m417.3-47q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m409.8-47q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m379.6-47q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "m371.8-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s28",
    d: "m356.8-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s33",
    d: "m326.6-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m296.3-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m281.1-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m273.6-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m258.3-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "m250.8-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m235.6-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m228.1-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s33",
    d: "m212.8-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m205.3-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s28",
    d: "m197.9-47q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m190.1-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m175.1-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s33",
    d: "m167.6-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m137.4-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m122.1-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m114.6-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m99.4-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "m91.9-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m76.6-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "m69.1-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m46.4-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s28",
    d: "m38.9-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s33",
    d: "m31.1-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s28",
    d: "m23.6-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m16.1-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s33",
    d: "m-14.1-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-21.6-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m-44.3-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-59.6-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "m-67.1-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-82.3-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "m-89.8-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m-112.6-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s33",
    d: "m-127.8-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m-135.3-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-203.3-47q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-218.5-47q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m-226-47q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-241.3-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "m-248.8-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-256.5-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-264-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m-271.5-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s33",
    d: "m-286.8-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m-294.3-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-362.3-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-377.5-47q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m-385-47q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m553.5-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m546-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m478-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m462.8-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m394.6-47q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m387.1-47q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m364.3-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m303.8-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m144.9-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m53.9-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m-36.8-47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m-105.1-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m-165.6-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m-195.8-47q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m-347.3-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m-354.8-47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m583.8-93.2q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m576.3-93.2q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m568.8-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m553.5-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m546-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m530.8-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m523.3-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m515.8-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m500.8-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m493-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m485.5-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m478-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m470.3-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m462.8-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m455.3-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m440-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m417.3-93.2q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m409.8-93.2q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m402-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m394.6-93.2q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m387.1-93.2q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m371.8-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m364.3-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m334.1-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m326.6-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m319.1-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m311.3-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m303.8-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m296.3-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m281.1-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m258.3-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m250.8-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m243.1-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m235.6-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m228.1-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m212.8-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m205.3-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m182.6-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m175.1-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m167.6-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m152.4-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m144.9-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m137.4-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m129.6-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m122.1-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m114.6-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m99.4-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m84.1-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m76.6-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m69.1-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m53.9-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m46.4-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m31.1-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s47",
    d: "m23.6-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m16.1-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m8.6-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m-6.6-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m-14.1-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m-21.6-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m-29.3-93.2q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m-36.8-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m-44.3-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-59.6-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-82.3-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m-89.8-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m-97.6-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m-105.1-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m-112.6-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m-120.3-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m-127.8-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m-135.3-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m-143.1-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m-150.3-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m-158.1-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m-165.6-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m-173.1-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-188.3-93.2q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m-195.8-93.2q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m-203.3-93.2q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-211-93.2q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-218.5-93.2q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-241.3-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m-248.8-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-256.5-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-264-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m-271.5-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m-279.3-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m-286.8-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m-294.3-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m-302-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m-317-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m-332-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m-347.3-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m-354.8-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m-362.3-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-370-93.2q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-377.5-93.2q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m-385-93.2q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-392.8-93.2q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m356.8 369q2 0 4 0 0 0.5 0 1-2 0-4 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m296.3 369q2 0 4 0 0 0.5 0 1-1.9 0-4 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m160.1 369q2 0 4 0 0 0.5 0 1-2 0-4 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m137.4 369q1.9 0 4 0 0 0.5 0 1-2 0-4 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m1.1 369q2 0 4 0 0 0.5 0 1-1.9 0-4 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-21.6 369q2 0 4 0 0 0.5 0 1-2 0-4 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-180.6 369q2 0 4 0 0 0.5 0 1-1.9 0-4 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-203.3 369q2 0 4 0 0 0.5 0 1-2 0-4 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-339.5 369q2 0 4 0 0 0.5 0 1-2 0-4 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-362.3 369q2 0 4 0 0 0.5 0 1-1.9 0-4 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m379.6 322.7q1.9 0 4 0 0 0.5 0 1-2 0-4 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m190.4 91.6q1.9 0 4 0 0 0.5 0 1-2 0-4 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m-309.3 91.6q2 0 4 0 0 0.5 0 1-1.9 0-4 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m561.3-93.2q1.9 0 4 0 0 0.5 0 1-2 0-4 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m538.5-93.2q2 0 4 0 0 0.5 0 1-2 0-4 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m379.6-93.2q1.9 0 4 0 0 0.5 0 1-2 0-4 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m356.8-93.2q2 0 4 0 0 0.5 0 1-2 0-4 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m220.6-93.2q2 0 4 0 0 0.5 0 1-2 0-4 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m197.9-93.2q1.9 0 3.9 0 0 0.5 0 1-1.9 0-3.9 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m190.4-93.2q1.9 0 4 0 0 0.5 0 1-2 0-4 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m61.6-93.2q2 0 4 0 0 0.5 0 1-1.9 0-4 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m38.9-93.2q2 0 4 0 0 0.5 0 1-2 0-4 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-309.3-93.2q2 0 4 0 0 0.5 0 1-1.9 0-4 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m-399.8 322.7q1.9 0 3.8 0 0 0.5 0 1-1.8 0-3.8 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s33",
    d: "m-399.8 184.1q1.9 0 3.8 0 0 0.5 0 1-1.8 0-3.8 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m-399.8 91.6q1.9 0 3.8 0 0 0.5 0 1-1.8 0-3.8 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m-399.8 45.3q1.9 0 3.8 0 0 0.5 0 1-1.8 0-3.8 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-399.5 230.4q1.7 0 3.5 0 0 0.5 0 1-1.7 0-3.5 0 0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-399.5-47q1.7 0 3.5 0 0 0.5 0 1-1.7 0-3.5 0 0-0.4 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m137.4 323q1.9 0 4 0 0 0.3 0 0.7-2 0-4 0 0-0.4 0-0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m-21.6 323q2 0 4 0 0 0.3 0 0.7-2 0-4 0 0-0.4 0-0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m-362.3 323q2 0 4 0 0 0.3 0 0.7-1.9 0-4 0 0-0.4 0-0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s53",
    d: "m561.3 368.7q2.1 0 4.2 0 0 0.6 0 1.3-0.1-0.4-0.2-0.8-1.9 0-3.8 0 0 0.4 0 0.8-0.2 0-0.5 0 0.1-0.6 0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s54",
    d: "m538.5 368.7q2.1 0 4.3 0 0 0.6 0 1.3-0.2-0.4-0.3-0.8-1.8 0-3.7 0 0 0.4 0 0.8-0.3 0-0.5 0 0.1-0.6 0.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s53",
    d: "m447.5 368.7q2.1 0 4.3 0 0.1 0.6 0.2 1.3-0.2 0-0.5 0 0-0.4 0-0.8-1.8 0-3.7 0-0.1 0.4-0.3 0.8 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s55",
    d: "m379.6 368.7q2 0 4.2 0 0 0.6 0 1.3-0.1-0.4-0.2-0.8-1.9 0-3.8 0 0 0.4 0 0.8-0.2 0-0.5 0 0.1-0.6 0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s53",
    d: "m288.6 368.7q2.1 0 4.2 0 0.1 0.6 0.3 1.3-0.3 0-0.5 0 0-0.4 0-0.8-1.9 0-3.8 0-0.1 0.4-0.2 0.8 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s53",
    d: "m220.6 368.7q2.1 0 4.2 0 0 0.6 0 1.3-0.1-0.4-0.2-0.8-1.9 0-3.8 0 0 0.4 0 0.8-0.2 0-0.5 0 0.2-0.6 0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s54",
    d: "m197.9 368.7q2 0 4.2 0 0 0.6 0 1.3-0.1-0.4-0.3-0.8-1.8 0-3.7 0 0 0.4 0 0.8-0.2 0-0.5 0 0.1-0.6 0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s53",
    d: "m61.6 368.7q2.1 0 4.3 0 0 0.6 0 1.3-0.1-0.4-0.3-0.8-1.8 0-3.7 0 0 0.4 0 0.8-0.3 0-0.5 0 0.1-0.6 0.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s54",
    d: "m38.9 368.7q2.1 0 4.2 0 0 0.6 0 1.3-0.1-0.4-0.2-0.8-1.9 0-3.8 0 0 0.4 0 0.8-0.2 0-0.5 0 0.2-0.6 0.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s53",
    d: "m-52.1 368.7q2.1 0 4.3 0 0.1 0.6 0.2 1.3-0.2 0-0.5 0 0-0.4 0-0.8-1.8 0-3.7 0-0.2 0.4-0.3 0.8 0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s54",
    d: "m159.9-93.2q0.1 0.3 0.2 0.7 1.9 0 3.8 0 0-0.3 0-0.7 0.2 0 0.5 0-0.2 0.6-0.3 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s54",
    d: "m0.9-93.2q0.1 0.3 0.2 0.7 1.9 0 3.8 0 0-0.3 0-0.7 0.2 0 0.5 0-0.1 0.6-0.3 1.2-2 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s54",
    d: "m-180.8-93.2q0.1 0.3 0.2 0.7 1.9 0 3.8 0 0-0.3 0-0.7 0.2 0 0.5 0-0.1 0.6-0.3 1.2-2 0-4.2 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s54",
    d: "m-339.8-93.2q0.2 0.3 0.3 0.7 1.8 0 3.7 0 0-0.3 0-0.7 0.3 0 0.5 0-0.1 0.6-0.2 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s56",
    d: "m107.1 368.7q2 0 4 0 0.1 0.6 0.3 1.3-0.3 0-0.5 0 0-0.4 0-0.8-1.9 0-3.8 0-0.1 0.4-0.2 0.8 0.1-0.6 0.2-1.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneSolidTwoDottedLine);
export default __webpack_public_path__ + "static/media/oneSolidTwoDottedLine.e1604e68147e2f74588ae83e8227813d.svg";
export { ForwardRef as ReactComponent };